import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { shareArticle } from '../../utils/shareUtils';

const getCategoryIcon = (categories) => {
  if (!categories || categories.length === 0) return FiIcons.FiFileText;
  const cat = categories[0].toLowerCase();
  if (cat.includes('tech') || cat.includes('gadget') || cat.includes('device')) return FiIcons.FiSmartphone;
  if (cat.includes('fashion') || cat.includes('style') || cat.includes('clothing')) return FiIcons.FiShoppingBag;
  if (cat.includes('food') || cat.includes('dining') || cat.includes('restaurant')) return FiIcons.FiCoffee;
  if (cat.includes('vehicle') || cat.includes('car') || cat.includes('auto')) return FiIcons.FiTruck;
  if (cat.includes('home') || cat.includes('living')) return FiIcons.FiHome;
  if (cat.includes('travel') || cat.includes('trip')) return FiIcons.FiMap;
  if (cat.includes('finance') || cat.includes('money')) return FiIcons.FiDollarSign;
  if (cat.includes('health') || cat.includes('wellness')) return FiIcons.FiHeart;
  if (cat.includes('game') || cat.includes('gaming')) return FiIcons.FiMonitor;
  return FiIcons.FiHash;
};

const StandardCard = ({ article, index }) => {
  const Icon = getCategoryIcon(article.categories);

  return (
    // Replaced generic div/a combo with semantic <article> wrapper for better search engine readability
    <motion.article 
      initial={{ opacity: 0, y: 20 }} 
      animate={{ opacity: 1, y: 0 }} 
      transition={{ duration: 0.4, delay: index * 0.05 }}
      className="group bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100 hover:-translate-y-1"
    >
      <a 
        href={article.link} 
        target="_blank" 
        rel="noopener noreferrer" 
        className="flex flex-row p-4 sm:p-5 gap-4 items-start h-full focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        {/* Icon Container */}
        <div className="h-12 w-12 sm:h-14 sm:w-14 flex-shrink-0 rounded-2xl bg-gradient-to-br from-blue-50 to-blue-100 text-blue-600 flex items-center justify-center group-hover:scale-110 group-hover:shadow-inner transition-all duration-300" aria-hidden="true">
          <SafeIcon icon={Icon} className="text-xl sm:text-2xl" />
        </div>

        {/* Content */}
        <div className="flex flex-col flex-grow min-w-0 h-full">
          <div className="flex justify-between items-start mb-1.5">
            {article.categories.length > 0 ? (
              <span className="text-[10px] font-bold uppercase tracking-widest text-blue-600 bg-blue-50 px-2.5 py-1 rounded-md truncate max-w-[150px]">
                {article.categories[0]}
              </span>
            ) : (
              <span className="text-[10px] font-bold uppercase tracking-widest text-gray-500 bg-gray-50 px-2.5 py-1 rounded-md">
                Article
              </span>
            )}
            
            <button 
              onClick={(e) => shareArticle(e, article)} 
              className="p-1.5 -mr-1.5 -mt-1.5 hover:bg-gray-100 rounded-full transition-colors text-gray-400 hover:text-blue-600 z-10 relative flex-shrink-0"
              aria-label={`Share article: ${article.title}`}
            >
              <SafeIcon icon={FiIcons.FiShare2} className="text-sm" aria-hidden="true" />
            </button>
          </div>
          
          <h3 className="text-base sm:text-[17px] font-serif font-bold text-gray-900 mb-1.5 leading-snug group-hover:text-blue-600 transition-colors line-clamp-2">
            {article.title}
          </h3>
          
          <p className="text-gray-500 text-xs sm:text-sm line-clamp-2 leading-relaxed">
            {article.summary}
          </p>
        </div>
      </a>
    </motion.article>
  );
};

export default StandardCard;